import { AccessError } from '@/models/errors/access-error';
import { GeneralError } from '@/models/errors/general-error';
import router from '@/router';
import { authService } from '@/services/auth-service';
import { HttpErrorEvent } from '@/services/event-bus';
import { Component, Vue } from 'vue-property-decorator';
import _ from '@/shared/lodash.global';

@Component
export default class GlobalErrorsComponent extends Vue {
    messagesToErrorFunctionMap: { [message: string]: Function } = {};

    mounted() {
        this.$bus.$on(HttpErrorEvent, this.handlHttpError)
    }

    private handlHttpError(e) {
        if (e instanceof AccessError) {
            authService.logOut().then(() => {
                if (!this.redirectUrlExist(router.currentRoute.fullPath)) {
                    router.push({
                        path: '/login',
                        query: { redirectUrl: router.currentRoute.fullPath }
                    })
                }
            })
        } else if (e instanceof GeneralError) {
            if (e.silent) { return; }

            let showErrorFunction = this.messagesToErrorFunctionMap[e.message]
            if (!showErrorFunction) {
                this.messagesToErrorFunctionMap[e.message] =
                    showErrorFunction = _.debounce(this.showErrorNotification, 1000);
            }
            showErrorFunction(e.message);
        }
    }

    private showErrorNotification(errorMessage: string) {
        this.$notify({
            group: 'global-errors',
            text: errorMessage,
            duration: -1,
        });
        delete this.messagesToErrorFunctionMap[errorMessage];
    }

    private redirectUrlExist(path: string): boolean {
        return path.includes('redirectUrl')
    }
}
